import React, { useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import PriceDiscount from "../../elements/price-discount";
import ProductDetailSelectionForm from "../product-detail-selection-form";
import GearSelectionCarousel from "../gear-selection-carousel";
import "./style.scss";

const ProductDetailSelection = React.forwardRef((props, ref) => {
  const {
    overlineText,
    headingType,
    headingBody,
    priceFormatted,
    discountedPriceFormatted,
    images,
    // selectedOptionId,
    intro,
    body,
    variants,
    availableVariants,
    cta,
    isProductWithVariations,
    warningMessage,
    soldOutMessage,
    isSoldOut,
    selectedOptionChanged = () => {},
    onRefLoaded = () => {}
  } = props;

  useEffect(() => {
    onRefLoaded();
  }, [ref]);

  const productDetailSelectionClasses = classNames("grid", "product-detail-selection");

  // const imageSlides = images
  //   ? images.find(item => item.optionId === selectedOptionId)
  //   : undefined;

  return (
    <section className={productDetailSelectionClasses}>
      <div className="product-detail-selection__header">
        <div className="product-detail-selection__heading">
          {overlineText && <span className="overline-text">{overlineText}</span>}
          {headingBody && headingBody.value && <Heading type={headingType} html={headingBody} typographyClass="type-h2" />}
        </div>
        <PriceDiscount price={priceFormatted} discountPrice={discountedPriceFormatted} />
      </div>
      {images && (
        <div className="product-detail-selection__carousel">
          <GearSelectionCarousel slides={images} />
        </div>
      )}

      <div className="product-detail-selection__details">
        {intro && (
          <Heading
            {...{
              html: { value: `<span class="type-h4">${intro}</span>` },
              type: { fields: { phrase: { value: "h4" } } },
              className: "body product-intro"
            }}
          />
        )}
        {body && (
          <BodyText
            {...{
              html: body,
              className: "body product-body"
            }}
          />
        )}
        {variants && variants.length > 0 && isProductWithVariations && <ProductDetailSelectionForm variants={variants} availableVariants={availableVariants} onSelectionChanged={selectedOption => selectedOptionChanged(selectedOption)} />}

        {warningMessage && (
          <div className="failed-message">
            <p>{warningMessage}</p>
          </div>
        )}
        <div ref={ref}>
          <PrimaryButton
            {...{
              ...cta,
              colorScheme: cta?.colorScheme || "outline-green",
              isDisabled: isSoldOut || cta.isDisabled
            }}
          />
        </div>
        {soldOutMessage && isSoldOut && (
          <div className="failed-message sold-out">
            <p>{soldOutMessage}</p>
          </div>
        )}
      </div>
    </section>
  );
});

ProductDetailSelection.displayName = "ProductDetailSelection";
export default ProductDetailSelection;

ProductDetailSelection.propTypes = {
  overlineText: PropTypes.string,
  heading: PropTypes.object,
  priceFormatted: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.object),
  selectedOptionId: PropTypes.number,
  intro: PropTypes.string,
  body: PropTypes.string,
  variants: PropTypes.arrayOf(PropTypes.object),
  cta: PropTypes.object
};
ProductDetailSelection.defaultProps = {};
